// firebase-config.js
import { initializeApp } from 'firebase/app';
import { getMessaging } from 'firebase/messaging';

// Your web app's Firebase configuration
const firebaseConfig = {
  apiKey: "AIzaSyCsRz_yecNLKbLMqlBKxpEOhxX7-Oh6Igk",
  authDomain: "ipeshare-live.firebaseapp.com",
  projectId: "ipeshare-live",
  storageBucket: "ipeshare-live.appspot.com",
  messagingSenderId: "243481547848",
  appId: "1:243481547848:web:1f4e9b38088ccd08c8f47d"
};

// Initialize Firebase
const app = initializeApp(firebaseConfig);

// Initialize Firebase Cloud Messaging and get a reference to the service
const messaging = getMessaging(app);

export { messaging };
